import { Col, Container, Row, Space, Typography, useMediaQuery } from '@ag1/ui';
import clsx from 'clsx';
import { useRef } from 'react';
import useAddAccessibility from 'shared/hooks/addAccessibility';
import { CustomPortableText } from 'shared/studio/PortableText';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { ImageAndTiles as ImageAndTilesProps, SanityKeyed } from 'types/studio/studio';
import UnifiedButton from '../../UnifiedButton/UnifiedButton';
import Badges from '../Badges/Badges';
import Heading from '../Heading/Heading';
import NumbersSection from '../NumbersSection/NumbersSection';
import styles from './Variation2.module.scss';

export const ImageAndTilesVariation2 = ({
  _type: sectionType,
  _key: key,
  contentPosition,
  headline,
  numbersOptions,
  badgesOptions,
  unifiedButton,
  padding
}: SanityKeyed<ImageAndTilesProps>) => {
  const contentLeft = contentPosition === 'left';
  const contentRef = useRef<HTMLDivElement>(null);

  useAddAccessibility(contentRef, true);

  const atSmall = useMediaQuery('m');

  return (
    <div
      ref={contentRef}
      id={key}
      className={clsx(
        styles.root,
        getSectionPaddingClasses(styles, padding),
        styles.mandatoryNoPadding
      )}>
      <Container narrow>
        <Row className={styles.row} align="between">
          <Col span={{ xxs: 12, m: 4 }}>
            <Space top={{ xxs: 40, s: 36, m: 0 }}>
              <Heading headline={headline} />
              {unifiedButton && atSmall && (
                <UnifiedButton
                  unifiedButton={unifiedButton}
                  sectionType={sectionType}
                  className={styles.button}
                  size="medium"
                />
              )}
            </Space>
          </Col>
          <Col span={{ xxs: 12, m: 7 }} className={clsx(contentLeft && styles.contentAtLeft)}>
            <Space top={{ xxs: 24, s: 36, m: 0 }}>
              <NumbersSection numbersOptions={numbersOptions} />
              <Badges badgesOptions={badgesOptions} />
              {numbersOptions?.footNote ? (
                <Typography
                  variant="portalCaption"
                  size="2"
                  color="grey-1-new"
                  noPadding
                  className={styles.footnote}>
                  <CustomPortableText value={numbersOptions.footNote} />
                </Typography>
              ) : (
                ''
              )}
              {unifiedButton && !atSmall && (
                <UnifiedButton
                  unifiedButton={unifiedButton}
                  sectionType={sectionType}
                  className={styles.button}
                  size="medium"
                />
              )}
            </Space>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
